// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zj2JnDaAFGfZcN {
  display: flex;
  flex-direction: row;
  padding: var(--ds-space-0, 0) 6px;
  transition: padding 0.2s ease-in-out;
  list-style: none;
}
.zj2JnDaAFGfZcN._3zcUgV3VaWFBs4 {
  /* stylelint-disable-next-line declaration-no-important, design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 44px !important;
}
.zj2JnDaAFGfZcN.t94pmCXiCS6Tu1 {
  /* stylelint-disable-next-line declaration-no-important, design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 28px !important;
}
.zj2JnDaAFGfZcN._3zcUgV3VaWFBs4.t94pmCXiCS6Tu1 {
  /* stylelint-disable-next-line declaration-no-important, design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 65px !important;
}
`, ""]);
// Exports
export var lists = `zj2JnDaAFGfZcN`;
export var islandNavPadding = `_3zcUgV3VaWFBs4`;
export var withLabels = `t94pmCXiCS6Tu1`;
export default ___CSS_LOADER_EXPORT___;
